import { render } from "./Health.vue?vue&type=template&id=491f796d&scoped=true&ts=true"
import script from "./Health.vue?vue&type=script&lang=ts"
export * from "./Health.vue?vue&type=script&lang=ts"

import "./Health.vue?vue&type=style&index=0&id=491f796d&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491f796d"]])

export default __exports__